import * as React from "react";
const LinkedinIcon = (props) => (
  <svg
    width={52}
    height={48}
    viewBox="0 0 52 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={52} height={48} rx={6} fill="url(#paint0_linear_11_528)" />
    <path
      d="M21.3908 20.7161V32.6667H18.1988V20.7161H21.3908ZM18 17.6015C18 17.1376 18.162 16.7547 18.486 16.4528C18.81 16.1509 19.2444 16 19.7893 16C20.3268 16 20.7575 16.1509 21.0815 16.4528C21.4129 16.7547 21.5785 17.1376 21.5785 17.6015C21.5785 18.0654 21.4129 18.4483 21.0815 18.7502C20.7575 19.0521 20.3268 19.203 19.7893 19.203C19.2444 19.203 18.81 19.0521 18.486 18.7502C18.162 18.4483 18 18.0654 18 17.6015Z"
      fill="white"
    />
    <path
      d="M27.1341 23.2675V32.6667H23.9532V20.7161H26.9353L27.1341 23.2675ZM26.6702 26.2717H25.8087C25.8087 25.3881 25.9228 24.5929 26.1511 23.886C26.3794 23.1718 26.6997 22.5643 27.112 22.0636C27.5243 21.5556 28.014 21.169 28.581 20.9039C29.1553 20.6315 29.7959 20.4953 30.5028 20.4953C31.0624 20.4953 31.5741 20.5762 32.038 20.7382C32.5019 20.9002 32.8995 21.1579 33.2308 21.5114C33.5695 21.8648 33.8273 22.3324 34.004 22.9141C34.1881 23.4958 34.2801 24.2063 34.2801 25.0457V32.6667H31.0771V25.0347C31.0771 24.5045 31.0035 24.0922 30.8562 23.7977C30.7089 23.5031 30.4917 23.297 30.2046 23.1791C29.9247 23.054 29.5787 22.9914 29.1663 22.9914C28.7393 22.9914 28.3674 23.0761 28.0508 23.2454C27.7416 23.4148 27.4838 23.6504 27.2777 23.9523C27.0789 24.2468 26.9279 24.5929 26.8248 24.9905C26.7217 25.3881 26.6702 25.8152 26.6702 26.2717Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11_528"
        x1={1.93715e-7}
        y1={24}
        x2={52}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor={
            process.env.NEXT_PUBLIC_CUSTOM_COLOR ? "#00343a" : "#4264AA"
          }
        />
        <stop
          offset={1}
          stopColor={
            process.env.NEXT_PUBLIC_CUSTOM_COLOR ? "#00343a" : "#853F89"
          }
        />
      </linearGradient>
    </defs>
  </svg>
);
export default LinkedinIcon;
